import { getUserprint } from '@narvar/userprint';

type UserprintResult = Awaited<ReturnType<typeof getUserprint>>;

let cachedUserprint: UserprintResult | null = null;
let isInitialized = false;

const FINGERPRINT_TIMEOUT = 3000;

const initPromise =
  typeof window !== 'undefined'
    ? Promise.race([
        getUserprint()
          .then((result) => {
            cachedUserprint = result;
            isInitialized = true;
          })
          .catch(() => {
            isInitialized = true;
          }),
        new Promise<void>((resolve) => {
          setTimeout(() => {
            isInitialized = true;
            resolve();
          }, FINGERPRINT_TIMEOUT);
        }),
      ])
    : Promise.resolve();

export const ensureFingerprintReady = async (): Promise<void> => {
  if (isInitialized) return;
  await initPromise;
};

export const getFingerprintHeaders = (): Record<string, string> => {
  const headers: Record<string, string> = {};

  const deviceSize = cachedUserprint?.device_size_px;
  if (deviceSize) {
    headers['X-Device-Size'] = deviceSize;
  }

  const fingerprint = cachedUserprint?.browser_fingerprint;
  if (fingerprint) {
    headers['X-Client-Fingerprint'] = fingerprint;
  }

  return headers;
};
